import http from "infra/http";
import { useQuery } from "react-query";
import { ParametrosCobrancaJurosResponse } from "../typings";

function useParametrosCobrancaJuros(tenant?: string) {
  const url = `v1/parametros-cobranca/${tenant}/juros`;
  return useQuery(
    url,
    async () => {
      const { data } = await http.get<ParametrosCobrancaJurosResponse>(url);
      return data;
    },
    {
      enabled: !!tenant,
    }
  );
}

export default useParametrosCobrancaJuros;
